import Vue from "vue";
import App from "./App.vue";
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin'

Vue.use(VueCookieBot, {
	cookieBotID: 'ed204ca5-6721-4636-a0d2-0720c3cec7ac'
})

Vue.config.productionTip = false;
new Vue({
	render: (h) => h(App),
	data: {
		apiUrl: process.env.VUE_APP_API_URL,
		backendUrl: process.env.VUE_APP_BACKEND_FILES,
		showAllergenSelect: false,
		translations: [],
		lang: null,
		searchOpen: false,
	},
}).$mount("#app");
